import React from 'react';
import { MListNavGroupVerticalProps } from './MListNavGroupVertical.types';
import { Wrapper, ListItem } from './MListNavGroupVertical.styles';
import { ASubheader } from '../../atoms/ASubheader/index';
import { AIcon } from '../../atoms/AIcon/index';

export function MListNavGroupVertical({ showSubheader, aSubheader, items = [] }: MListNavGroupVerticalProps) {
  return (
    <Wrapper data-testid="m-list-nav-group-vertical">
      {showSubheader && aSubheader && <ASubheader {...aSubheader} />}
      <ul className="p-0 m-0">
        {items.map((item, index) => {
          const { text, arrow, aIcon } = item;
          const iconProps = arrow ? { icon: 'icon-arrow-right' } : aIcon;
          return (
            <ListItem key={index} data-testid="m-list-nav-item">
              {iconProps && <AIcon {...iconProps} className="mr-2" />}
              <span>{text}</span>
            </ListItem>
          );
        })}
      </ul>
    </Wrapper>
  );
}
